(() => {
    const refreshYotpo = () => {
        requestAnimationFrame(() => {
            if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
                window.yotpoWidgetsContainer.initWidgets();
                return;
            }

            if (typeof window.yotpo?.refreshWidgets === 'function') {
                window.yotpo.refreshWidgets();
                return;
            }

            if (typeof window.yotpo?.initWidgets === 'function') {
                window.yotpo.initWidgets();
            }
        });
    };

    const releaseWidgetHeights = () => {
        for (const el of document.querySelectorAll('.yotpo-widget-instance')) {
            el.style.minHeight = '';
        }
    };

    const onBreakpointChange = () => {
        releaseWidgetHeights();
        refreshYotpo();
    };

    for (const query of ['(min-width: 768px)', '(min-width: 1024px)']) {
        window.matchMedia(query).addEventListener('change', onBreakpointChange);
    }
})();
